<template>
  <div v-if="display">
    <template v-if="mode === 'default'">
      <footer class="f-row ctr footer-default">
        <span>agil.net</span>
      </footer>
    </template>
    <template v-else-if="mode === 'editor'">
      <footer class="f-row ctr footer-editor">
        <span>agil.net</span>
      </footer>
    </template>
    <template v-else-if="mode === 'outside'">
      <footer class="f-row ctr footer-outside">
        <span>agil.net</span>
      </footer>
    </template>
  </div>
</template>

<script>
export default {
  name: "Footer",
  computed: {
    display() {
      return this.$store.state.footer.display;
    },
    mode() {
      return this.$store.state.footer.mode;
    },
  },
};
</script>

<style scoped>
.footer-default {
  justify-content: flex-end;
  height: 22px;
  max-height: 22px;
  min-height: 22px;
  padding: 0 0.6rem;
  text-transform: uppercase;
  font-size: 10px;
  font-weight: 600;
  color: #2e3e4e;
  background-color: #f9f9f9;
  border-top: 1px solid #ddd;
}

.footer-editor {
  display: none;
}

.footer-outside {
  justify-content: flex-end;
  height: 22px;
  max-height: 22px;
  min-height: 22px;
  padding: 0 0.6rem;
  text-transform: uppercase;
  font-size: 10px;
  font-weight: 600;
  color: #2e3e4e;
  background-color: #f9f9f9;
  border-top: 1px solid #ddd;
}
</style>